export function init(name) {
    const item = $(name);
    const parent = item.parents(name + '-parent');

    if (!item.length || !parent.length) {
        return;
    }

    const content = item.html();

    item.remove();

    parent.append(content);

    setTimeout(function() {
        $(window).trigger('resize');
    }, 1000);
}
